import {Button} from '@luminopia/react-toolbox/lib/button'
import Form, {ITheme as IFormTheme} from 'core/components/form/Form'
import TextField, {ITextFieldProps, ITheme as ITextFieldTheme} from 'core/components/form/text-field'
import {createValidator, required} from 'core/validation'
import * as React from 'react'
import {Field, FormProps, reduxForm, SubmitHandler} from 'redux-form'
import * as classNames from './LoginForm.css'

export interface IFormFields {
  email: string
  password: string
}

interface ITheme extends IFormTheme {
  button?: string
  textFieldTheme?: ITextFieldTheme
}

interface IProps extends FormProps<IFormFields, {}, {}> {
  theme?: ITheme
}

/**
 * Email-password login form intended for use with redux-form.
 */
class LoginForm extends React.PureComponent<IProps, {}> {
  public render(): React.ReactElement<{}> {
    const { handleSubmit, pristine, submitting, error, theme = {} } = this.props
    const emailProps: ITextFieldProps = {
      label: 'Email',
      placeholder: 'Email',
      onEnter: handleSubmit,
      theme: theme.textFieldTheme,
    }
    const passwordProps: ITextFieldProps = {
      type: 'password',
      label: 'Password',
      placeholder: 'Password',
      onEnter: handleSubmit,
      theme: theme.textFieldTheme,
    }

    const formTheme: IFormTheme = {
      error: theme.error,
    }

    return (
      <Form onSubmit={handleSubmit} error={error} theme={formTheme}>
        <Field name='email' component={TextField} props={emailProps}/>
        <Field name='password' component={TextField} props={passwordProps}/>
        <Button
          className={classNames.button}
          icon='arrow_forward'
          disabled={pristine || submitting}
          raised primary
          onClick={handleSubmit}
        >
        </Button>
      </Form>
    )
  }
}

export default LoginForm

/**
 * Component factory for creating login forms, intended for use with redux-form.
 *
 * @param formName key to where your form's state will be mounted under the redux-form reducer
 * @param onSubmit fn called when prop `handleSubmit` is fired
 */
export const loginFormFactory = (
  {
    formName,
    onSubmit,
  }: {
    formName: string,
    onSubmit: SubmitHandler<IFormFields, {}, {}>,
  },
) => {
  const initialValues: IFormFields = {
    email: '',
    password: '',
  }

  const formDecorator = reduxForm<IFormFields, {}, {}>({
    form: formName,
    initialValues,
    onSubmit,
    validate: createValidator({
      email: [required],
      password: [required],
    }),
  })

  return formDecorator(LoginForm)
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/login/LoginForm.tsx